import * as React from "react";

import Setup from "./Setup";
import { RouteComponentProps } from "react-router";

export default function Welcome(props: RouteComponentProps<{}, {}>) {
  return <Setup {...props} />;
}
